import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../../utils/session.service';
import Config from '../../../utils/config.service';
import PreVisitRecordTicketForPersonService from '../../../services/pre-visit-record-ticket-for-person.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'pre-visit-card',
	templateUrl: './pre-visit-card.component.html',
	imports: [ CommonModule, FormsModule, RouterLink ]
})
export class PreVisitCardComponent implements OnInit {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private preVisitRecordTicketForPersonService: PreVisitRecordTicketForPersonService = inject(PreVisitRecordTicketForPersonService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() settings: any | undefined;
	@Input() service: any | undefined;
	@Input() isNarrow: any | undefined;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isRecordTicketForPerson = false;
		this.vm.isBusinessUser = false;
		this.vm.isRecordTicketForPerson = !!this.preVisitRecordTicketForPersonService.getPatient();
		this.vm.preVisitSettings = this.preVisitRecordTicketForPersonService.getSettings();
		if (this.vm.preVisitSettings 
			&& this.vm.preVisitSettings.preVisitNewHealthProblemConfig 
			&& this.vm.preVisitSettings.preVisitNewHealthProblemConfig === 'FREE_TEXT') {
			this.vm.freeText = true;
		}
		this.vm.isBusinessUser = !!this.session.getSession().user.businessUser;
		
		this.vm.isServiceAllowed = this.isServiceAllowed
		this.handleComponentInit();
	}
	
	isServiceAllowed(service) {
		return !this.config.isOnDemandServiceUnavailable(service);
	}
	
	handleComponentInit() {
		var location: any = window.location.href;
		if (location.includes('eelvisiit')) {
			this.vm.previsitLocation = true;
		}
		
		switch (this.vm.service) {
			case 'NEW_HEALTH_PROBLEM':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-new-health-problem.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-pharma.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NewHealthProblem'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NewHealthProblem');
				
				if (this.vm.freeText) {
					this.vm.link = ['/symptom-check-simple'];
				} else {
					this.vm.link = ['/symptom-check/introduction'];
				}
				this.vm.queryParams = {type: 'pre-visit'};
				this.vm.linkId = 'preVisitSymptomCheckButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'PRESCRIPTION_RENEW_REQUEST':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-prescriptions.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-prescription.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_PrescriptionRenewRequest'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_PrescriptionRenewRequest');
				if (this.vm.isRecordTicketForPerson && !this.vm.isBusinessUser) {
					this.vm.link = ['/pre-visit/service/request'];
					this.vm.queryParams = {parentCategory: 'NEW_PRESCRIPTION_REQUEST'};
					this.vm.linkId = 'preVisitOtherPersonNewPrescriptionRequestButton';
				} else {
					this.vm.link = ['/prescription-list'];
					this.vm.queryParams = {type: 'pre-visit'};
					this.vm.linkId = 'preVisitPrescriptionListButton';
				}
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'HEALTHY_PATIENT_VISIT':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-healthy-patient.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-doctor.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NewHealthyPatientRequest'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NewHealthyPatientRequest');
				this.vm.link = ['/pre-visit'];
				this.vm.queryParams = {parentCategory: 'HEALTHY_PATIENT_VISIT'};
				this.vm.linkId = 'preVisitHealthyPatientVisitButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'MENTAL_HEALTH':
			{
				var mental: any = this.vm.settings.filter((item) => {
					return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && item.furtherSubcategory === 'MENTAL_CHECK';
				})[0];
				
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-mental-health.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-mental.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NewMentalHealth'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NewMentalHealth');
				this.vm.link = ['/pre-visit/mental-check'];
				this.vm.linkId = 'preVisitMentalCheckButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				if (!this.vm.isServiceAllowed(mental)) {
					var isDaylightSavingTime: any = moment().isDST();
					var timezoneOffsetHours: any = isDaylightSavingTime ? 3 : 2;
					var startTimeHours: any = (24 + mental.startTimeInHours + timezoneOffsetHours) % 24;
					var startTime: any = ('0' + startTimeHours).slice(-2) + ':00';
					var endTimeHours: any = (24 + mental.endTimeInHours + timezoneOffsetHours) % 24;
					var endTime: any = ('0' + endTimeHours).slice(-2) + ':00';
					this.vm.notAvailableText = this.angularFilterHelperService.translate('PreVisit.Card.Text_NewMentalHealthUnavailable')
						.replace('%s', startTime).replace('%e', endTime);
				}
				
				break;
			}
			
			case 'HEALTH_CERTIFICATE_REQUEST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-health-certificate.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_HEALTH_CERTIFICATE_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_HEALTH_CERTIFICATE_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'HEALTH_CERTIFICATE_REQUEST'};
				this.vm.linkId = 'preVisitHealthCertificateButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'CHILD_RELATED_REQUEST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-child.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_CHILD_RELATED_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_CHILD_RELATED_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'CHILD_RELATED_REQUEST'};
				this.vm.linkId = 'preVisitChildRelatedRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'VACCINATION_REQUEST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-vaccination.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_VACCINATION_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_VACCINATION_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'VACCINATION_REQUEST'};
				this.vm.linkId = 'preVisitVaccinationButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'HEALTH_CHECKUP_REQUEST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-health-checkup.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_HEALTH_CHECKUP_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_HEALTH_CHECKUP_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'HEALTH_CHECKUP_REQUEST'};
				this.vm.linkId = 'preVisitHealthCheckUpRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'NEW_PRESCRIPTION_REQUEST':
			{
				this.vm.imageUrl = 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-prescription-consult.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_PRESCRIPTION_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_PRESCRIPTION_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'NEW_PRESCRIPTION_REQUEST'};
				this.vm.linkId = 'preVisitNewPrescriptionRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'CHRONICALLY_ILL_VISIT_REQUEST':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-chronically-ill.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-chronically-ill.svg';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_CHRONICALLY_ILL_VISIT_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_CHRONICALLY_ILL_VISIT_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'CHRONICALLY_ILL_VISIT_REQUEST'};
				this.vm.linkId = 'preVisitChronicallyIllVisitRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'SICK_LEAVE_CERTIFICATE_REQUEST':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-sick-leave.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-sick-leave-3.png';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_SICK_LEAVE_CERTIFICATE_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_SICK_LEAVE_CERTIFICATE_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'SICK_LEAVE_CERTIFICATE_REQUEST'};
				this.vm.linkId = 'preVisitSickLeaveRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			case 'FOLLOW_UP_REQUEST':
			{
				this.vm.imageUrl = this.vm.previsitLocation
					? 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/previsit/previsit-follow-up.svg'
					: 'https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/od-follow-up-3.png';
				this.vm.title = this.angularHelperService.trustAsHtml(
					this.angularFilterHelperService.translate('PreVisit.Card.Title_NEW_FOLLOW_UP_REQUEST'));
				this.vm.text = this.angularFilterHelperService.translate('PreVisit.Card.Text_NEW_FOLLOW_UP_REQUEST');
				this.vm.link = ['/pre-visit/service/request'];
				this.vm.queryParams = {parentCategory: 'FOLLOW_UP_REQUEST'};
				this.vm.linkId = 'preVisitFollowUpRequestButton';
				this.vm.btnText = this.angularFilterHelperService.translate('Common.Next');
				break;
			}
			default:
			break;
		}
	}
	
}